import { Switch } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import React from 'react';
import { Controller, FieldPath, FieldValues, UseControllerProps } from 'react-hook-form';

interface ControlledSwitchProps<T extends FieldValues, TName extends FieldPath<T>>
  extends UseControllerProps<T, TName> {
  label: string;
  disabled?: boolean;
  helperText?: string;
}

const ControlledSwitch = <T extends FieldValues, TName extends FieldPath<T>>({
  label,
  disabled,
  helperText,
  ...controllerProps
}: ControlledSwitchProps<T, TName>) => {
  return (
    <>
      <FormControlLabel
        control={
          <Controller
            {...controllerProps}
            render={({ field }) => (
              <Switch
                {...field}
                disabled={disabled}
                onChange={(e) => field.onChange(e.target.checked)}
                checked={field.value}
              />
            )}
          />
        }
        label={label}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </>
  );
};

export default ControlledSwitch;
